/**
 * Product hide/show for PWA vs website.
 *
 * PWA mode when any of:
 *   - ?view=pwa in URL
 *   - localStorage `pwa-channel-mode` === "pwa" (theme product key)
 *   - progressify-me.isInApp === true (READ ONLY — never modified here)
 *
 * Does not write/change progressify-me.
 */
(function () {
  const PRODUCT_CHANNEL_KEY = 'pwa-channel-mode';
  const PROGRESSIFY_KEY = 'progressify-me';
  const RESTRICT_APP = 'only for pwa app';
  const RESTRICT_WEB = 'only for website';

  function isProductPwaFlag() {
    try {
      return localStorage.getItem(PRODUCT_CHANNEL_KEY) === 'pwa';
    } catch (e) {
      return false;
    }
  }

  /** Read-only — never setItem/removeItem on progressify-me */
  function isInAppFromProgressify() {
    try {
      const raw = localStorage.getItem(PROGRESSIFY_KEY);
      if (!raw) return false;
      const data = JSON.parse(raw);
      return !!(data && data.isInApp === true);
    } catch (e) {
      return false;
    }
  }

  function isPwaFromUrl() {
    return new URLSearchParams(window.location.search).get('view') === 'pwa';
  }

  function isPwaMode() {
    return isPwaFromUrl() || isProductPwaFlag() || isInAppFromProgressify();
  }

  /**
   * If Progressify already marked in-app, mirror onto our product key only.
   * progressify-me itself is never written.
   */
  function syncProductKeyFromProgressify() {
    if (!isInAppFromProgressify() && !isPwaFromUrl()) return;
    try {
      if (localStorage.getItem(PRODUCT_CHANNEL_KEY) !== 'pwa') {
        localStorage.setItem(PRODUCT_CHANNEL_KEY, 'pwa');
      }
    } catch (e) {}
  }

  function applyPwaVisibility(root) {
    syncProductKeyFromProgressify();
    const isPwa = isPwaMode();
    document.documentElement.classList.toggle('pwa-mode', isPwa);
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-pwa-restrict="' + RESTRICT_APP + '"]').forEach((el) => {
      if (isPwa) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });

    scope.querySelectorAll('[data-pwa-restrict="' + RESTRICT_WEB + '"]').forEach((el) => {
      if (isPwa) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
  }

  window.PwaMode = {
    isProductPwaFlag,
    isInAppFromProgressify,
    isPwaFromUrl,
    isPwaMode,
    refresh: applyPwaVisibility,
  };

  applyPwaVisibility();

  if (window.MutationObserver) {
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) applyPwaVisibility(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('storage', (event) => {
    if (event.key === PRODUCT_CHANNEL_KEY || event.key === PROGRESSIFY_KEY) {
      applyPwaVisibility();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) applyPwaVisibility();
  });

  var pwaPollCount = 0;
  var pwaPollId = setInterval(function () {
    applyPwaVisibility();
    pwaPollCount += 1;
    if (pwaPollCount >= 10) clearInterval(pwaPollId);
  }, 500);
})();
